import { render, staticRenderFns } from "./teacherList.vue?vue&type=template&id=06a06345&scoped=true"
import script from "./teacherList.vue?vue&type=script&lang=js"
export * from "./teacherList.vue?vue&type=script&lang=js"
import style0 from "./teacherList.vue?vue&type=style&index=0&id=06a06345&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a06345",
  null
  
)

export default component.exports